<template>
    <div>
        <!--Begin Checkout Banner section-->
        <!--<section class="checkout-banner">-->
        <!--<div class="checkout-banner-image">-->
        <!--<img src="assets/images/content/checkout-banner.jpg" alt="image" />-->
        <!--</div>-->
        <!--<div class="checkout-banner-content">-->
        <!--<h2>Checkout</h2>-->
        <!--</div>-->
        <!--</section>        -->
        <!--End Checkout Banner section-->

        <!--Begin Progress section-->
        <!--<section class="progress-outer">-->
        <!--<ul>-->
        <!--<li><a href="#" class="active">Add funds</a></li>-->
        <!--<li><a href="#" class="active">Review &amp; Place Order</a></li>-->
        <!--<li><a href="#" class="active">Confirmation</a></li>-->
        <!--</ul>            -->
        <!--</section>        -->
        <!--End Progress section-->

        <!--Begin Progress Content-->
        <section class="progress-content-outer">
            <div class="progress-content-inner">
                <h1 class="title-1">Thanks for your support!</h1>
                <p class="donation-received">Your donation has been received. Please print this page for your records.</p>
                <hr>
                <p class="paragraph" style="margin-top: 40px">{{donation.formatted_date}}</p>
                <p class="name-donor">{{donation.name}}</p>
                <p class="paragraph">donated  <b class="amount-donation">$ {{donation.formatted_amount}}</b> to <b>{{fundraiser.name}}'s</b> classroom to fund their Classroom Supply Box.</p>
                <p class="paragraph">Sincere thanks from the <b>Kids In Need Foundation</b> for your support of students in <b>{{fundraiser.teacher.state_name}}</b>!</p>
                <p class="paragraph">The Kids In Need Foundation is a recognized 501(c)(3) charity founded in 1995. Contributions to Kids In Need are tax-deductibles to the greatest extent of the law.</p>
                <p class="rights-reserved"><a href="https://www.kinf.org/donor-privacy-policy/">Donor Privacy Policy</a> | Copyright ©2007-2018. All rights reserved. EIN 82-1078462</p>
                <div class="single-row">
                    <div class="col text-center">
                        <button class="solid-btn" style="width: 200px" onclick="print()"><i class="fa fa-print" style="margin-right: 8px"></i>Print</button>

                    </div>
                </div>
                <br>
                <hr style="margin-bottom: 40px">
                <i class="share">Share</i>
                <div class="split-row">
                    <div class="split-col">
                        <a :href="getFacebookLink()" target="_blank" class="solid-btn"><i class="fa fa-facebook" aria-hidden="true"></i>Facebook</a>
                    </div>
                    <div class="split-col">
                        <a :href="getTwitterLink()" target="_blank" class="solid-btn"><i class="fa fa-twitter" aria-hidden="true"></i> Tweet</a>
                    </div>
                </div>
            </div>
        </section>
        <!--End Progress Content-->

        <!--Begin Payment Information-->
        <section class="payment-information-outer">
            <div class="payment-information-inner">
                <!--<div class="card-info">-->
                    <!--<div v-show="!showThankYou">-->
                        <!--&lt;!&ndash;<h4 class="title-4" style="margin-bottom: 15px">Leave a comment</h4>&ndash;&gt;-->
                        <!--<h5 class="title-5">Would you like to add an encouraging note to help support this classroom?</h5>-->
                        <!--<div class="billing-info">-->
                            <!--<div class="row">-->
                                <!--<div class="col-12">-->
                                    <!--<div class="input">-->
                                        <!--<textarea v-model="comment" class="input-field" value=""-->
                                                  <!--placeholder="Leave your comment here..."-->
                                                  <!--:class="{'red-hover': payloadErrors.comment}"-->
                                                  <!--rows="5" type="text" width="100%"></textarea>-->
                                    <!--</div>-->
                                    <!--&lt;!&ndash;<span v-show="payloadErrors.comment"&ndash;&gt;-->
                                          <!--&lt;!&ndash;class="text-danger">Please enter your comment</span>&ndash;&gt;-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="single-row" style="margin-top: 10px;">-->
                                <!--<button class="solid-btn" @click="saveComment">Comment</button>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div v-show="showThankYou">-->
                        <!--<h4 class="title-4">Thank you for your comment</h4>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="btn-group">
                    <div class="split-row">
                        <div class="split-col">
                            <a :href="getFundraiserRoute"
                               class="solid-btn outline icon-left">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                                Back
                            </a>
                        </div>
                        <div class="split-col">
                            <a :href="getFilterRoute"
                               class="solid-btn outline icon-left">
                                <i class="fas fa-graduation-cap"></i>
                                Supply another classroom
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--End Payment Information-->

    </div>
</template>

<script>
    export default {
        props: {
            donation: {
                required: true
            },
            commentRoute: {
                required: true
            },
            fundraiser: {
                required: true
            }            
        },
        data() {
            return {
                comment: '',
                validating: false,
                showThankYou: false,
                routes: {},
            }
        },
        computed: {
            payloadErrors() {
                return {
                    comment: this.validating && this.comment.trim() === ""
                }
            },
            payload() {
                return {
                    body: this.comment.trim(),
                    donation_id: this.donation.id,
                }
            },
            getFundraiserRoute() {
                return this.routes.fundraiser_show + '/' + this.fundraiser.slug;
            },
            getFilterRoute(){
                return this.routes.teachers_index;
            },
        },
        methods: {
            saveComment() {
                if (this.validate()) {
                    axios.post(this.commentRoute, this.payload)
                        .then(response => {
                            this.$notify({
                                title: 'Success',
                                message: response.data.response.message,
                                type: 'success'
                            });
                            this.showThankYou = true;
                        }).catch(e => {
                        console.log(e)
                    })

                }
            },
            validate() {
                console.log(this.validating);
                this.validating= true;
                let hasError = false;
                for (let x in this.payloadErrors) {
                    if (this.payloadErrors[x]) {
                        hasError = true;
                    }
                }
                return !hasError;
            },
            getTwitterLink() {
                let url = 'https://twitter.com/intent/tweet?';

                    url += 'text=I just helped classrooms across the country get the school supplies they need from SupplyAClassroom.org! You can help, too. #ClassroomSupplyBox';
                    url += '&url=' + this.getShareUrl();

                    return url;
            },
            getFacebookLink() {
                let url = 'https://www.facebook.com/sharer/sharer.php?u=';
                    url += this.getShareUrl();

                return url;
            },
            getShareUrl() {
                return this.routes.app + '/fundraiser/' + this.fundraiser.slug;
            }            
        },
        mounted() {
            window.kinfEvents.$on('PageThankYou:sendRoutes', (routes) => {
                this.routes = routes;
            })            
        }
    }
</script>

<style>
    .donation-received{
        margin-bottom: 50px;
        font-family: 'Rubik-Medium';
        font-size: 24px;
        line-height: 32px;
        color: #4a4a4a;
    }

    .name-donor{
        font-family: 'RobotoSlab-Bold';
        font-size: 24px;
        line-height: 32px;
        margin-top: 30px;
        margin-bottom: 0px !important;
    }

    p>b.amount-donation{
        color: #FD8205;
        font-family: "Rubik-Bold";

    }

    .rights-reserved{
        font-family: "Rubik-Regular";
        font-size: 16px;
        line-height: 29px;
        color: #4a4a4a;
    }

</style>



// WEBPACK FOOTER //
// resources/js/views/checkout/components/thankyou/PageThankYou.vue